/* unplugin-vue-components disabled */import { render } from "./w-pdf-viewer-dialog.vue?vue&type=template&id=977c5318&scoped=true&ts=true"
import script from "./w-pdf-viewer-dialog.vue?vue&type=script&lang=ts"
export * from "./w-pdf-viewer-dialog.vue?vue&type=script&lang=ts"

import "./w-pdf-viewer-dialog.vue?vue&type=style&index=0&id=977c5318&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977c5318"]])

export default __exports__